import { Link, useRouterState } from '@tanstack/react-router';
import { Icon } from './Icon.tsx';
import { useAuthStore } from '../store/auth.ts';

// Material 3 FAB (mobile) — the primary "Send a document" action, floating above
// the navigation bar on the main list screens. Hidden on detail/form screens and
// for SYS_ADMINs.
export function MobileFab(): JSX.Element | null {
  const user = useAuthStore((s) => s.user);
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  if (!user || user.role === 'SYS_ADMIN') return null;
  const show = pathname === '/dashboard' || pathname === '/inbox';
  if (!show) return null;

  return (
    <Link
      to="/documents/new"
      aria-label="Send a document"
      className="md:hidden fixed right-4 z-40 flex h-14 items-center gap-2.5 rounded-2xl pl-4 pr-5 bg-[hsl(var(--primary-container))] text-[hsl(var(--on-primary-container))] font-medium shadow-lg active:scale-95 transition-transform"
      style={{ bottom: 'calc(5.75rem + env(safe-area-inset-bottom))' }}
    >
      <Icon name="add" size={24} />
      Send
    </Link>
  );
}
